export const STORAGE_KEYS = {
    localUser: 'localUser',
    userLogged: 'userLogged'
}